import { render, staticRenderFns } from "./index-detail.vue?vue&type=template&id=41399093&scoped=true&"
import script from "./index-detail.vue?vue&type=script&lang=js&"
export * from "./index-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41399093",
  null
  
)

export default component.exports